/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_EsppOfferingPeriodRow } from '../models/PagedResultDto_EsppOfferingPeriodRow';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodCreateDto } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodCreateDto';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodCreateResponseDto } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodCreateResponseDto';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDeleteResponseDto } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDeleteResponseDto';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDocumentDto } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDocumentDto';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodMiniRow } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodMiniRow';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodRow } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodRow';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodUpdateDto } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodUpdateDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';
import type { Wealthlane_Shared_Hosting_Dtos_GenericRemarksDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericRemarksDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto';
import type { Wealthlane_Shared_Hosting_Dtos_PlanDocumentInfoDto } from '../models/Wealthlane_Shared_Hosting_Dtos_PlanDocumentInfoDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EsppOfferingPeriodService {

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodCreateResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAwardOfferingPeriod(
        requestBody?: Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodCreateDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodCreateResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/award/offering-period',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodStartDate
     * @param offeringPeriodEndDate
     * @param status
     * @param offeringPeriodType
     * @param planIds
     * @param lookback
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_EsppOfferingPeriodRow OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardOfferingPeriod(
        offeringPeriodStartDate?: string,
        offeringPeriodEndDate?: string,
        status?: Array<string>,
        offeringPeriodType?: Array<string>,
        planIds?: Array<string>,
        lookback?: boolean,
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_EsppOfferingPeriodRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/offering-period',
            query: {
                'OfferingPeriodStartDate': offeringPeriodStartDate,
                'OfferingPeriodEndDate': offeringPeriodEndDate,
                'Status': status,
                'OfferingPeriodType': offeringPeriodType,
                'PlanIds': planIds,
                'Lookback': lookback,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAwardOfferingPeriodImport(
        formData?: {
            File?: Blob;
        },
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/award/offering-period/import',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardOfferingPeriodTemplateExport(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/offering-period/template/export',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodCreateResponseDto OK
     * @throws ApiError
     */
    public static patchApiAwardApiAwardOfferingPeriod(
        offeringPeriodId: string,
        requestBody?: Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodUpdateDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodCreateResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}',
            path: {
                'offeringPeriodId': offeringPeriodId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDeleteResponseDto OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAwardOfferingPeriod(
        offeringPeriodId: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDeleteResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}',
            path: {
                'offeringPeriodId': offeringPeriodId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodRow OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardOfferingPeriod1(
        offeringPeriodId: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}',
            path: {
                'offeringPeriodId': offeringPeriodId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static patchApiAwardApiAwardOfferingPeriodDocument(
        offeringPeriodId: string,
        requestBody?: Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDocumentDto,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/document',
            path: {
                'offeringPeriodId': offeringPeriodId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @returns Wealthlane_Shared_Hosting_Dtos_PlanDocumentInfoDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardOfferingPeriodDocument(
        offeringPeriodId: string,
    ): CancelablePromise<Array<Wealthlane_Shared_Hosting_Dtos_PlanDocumentInfoDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/document',
            path: {
                'offeringPeriodId': offeringPeriodId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDeleteResponseDto OK
     * @throws ApiError
     */
    public static patchApiAwardApiAwardOfferingPeriodStatusPublish(
        offeringPeriodId: string,
        requestBody?: Wealthlane_Shared_Hosting_Dtos_GenericRemarksDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDeleteResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/status/publish',
            path: {
                'offeringPeriodId': offeringPeriodId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDeleteResponseDto OK
     * @throws ApiError
     */
    public static patchApiAwardApiAwardOfferingPeriodStatusApprove(
        offeringPeriodId: string,
        requestBody?: Wealthlane_Shared_Hosting_Dtos_GenericRemarksDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDeleteResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/status/approve',
            path: {
                'offeringPeriodId': offeringPeriodId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDeleteResponseDto OK
     * @throws ApiError
     */
    public static patchApiAwardApiAwardOfferingPeriodStatusPublishRevert(
        offeringPeriodId: string,
        requestBody?: Wealthlane_Shared_Hosting_Dtos_GenericRemarksDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDeleteResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/status/publish/revert',
            path: {
                'offeringPeriodId': offeringPeriodId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDeleteResponseDto OK
     * @throws ApiError
     */
    public static patchApiAwardApiAwardOfferingPeriodStatusReject(
        offeringPeriodId: string,
        requestBody?: Wealthlane_Shared_Hosting_Dtos_GenericRemarksDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDeleteResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/status/reject',
            path: {
                'offeringPeriodId': offeringPeriodId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDeleteResponseDto OK
     * @throws ApiError
     */
    public static patchApiAwardApiAwardOfferingPeriodStatusPending(
        offeringPeriodId: string,
        requestBody?: Wealthlane_Shared_Hosting_Dtos_GenericRemarksDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodDeleteResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/award/api/award/offering-period/{offeringPeriodId}/status/pending',
            path: {
                'offeringPeriodId': offeringPeriodId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @param periodType
     * @param after
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodMiniRow OK
     * @throws ApiError
     */
    public static getApiAwardApiAwardOfferingPeriodPotentialNextOfferingPeriods(
        offeringPeriodId?: string,
        periodType?: string,
        after?: string,
    ): CancelablePromise<Array<Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodMiniRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/award/offering-period/potential-next-offering-periods',
            query: {
                'offeringPeriodId': offeringPeriodId,
                'periodType': periodType,
                'after': after,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
